#import "../fragments/entity-summary-fragment.graphql"

query GetEntitySummary($id: ID!) {
    entitySummary(id: $id) {
        ...EntitySummaryFragment
    }
}
